import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import Heading from '../../components/Heading';
import AboutHoldingSection from '../../components/AboutHoldingSection';
import HoldingAdvantages from '../../components/HoldingAdvantages';
import Select from '../../components/Select';
import CitySelect from '../../components/CitySelect';
import Button from '../../components/Button';
import CustomLink from "../../components/CustomLink";
import CustomMap from '../../components/CustomMap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { setFilterData } from "../../actions/FiltersActions";
import company__rtelecom_xxl from '../../assets/imgs/company__rtelecom--xxl.png';
import heading__about from '../../assets/imgs/aboutPage_banner.jpg';
import heading__about_1024 from '../../assets/imgs/aboutPage_banner.jpg';
import requestAll from '../../actions/Common';
import { bindActionCreators } from 'redux';
import { loadAbout } from '../../actions/AboutActions';
import { loadVacancies } from '../../actions/VacanciesActions';
import { loadScopeActivity } from '../../actions/ScopeActivityActions';
import { loadCompanies } from '../../actions/CompaniesActions';
import FeatureBlock from "../../components/FeatureBlock/FeatureBlock";
import Block1 from "../../components/FeatureBlock/images/image_1.jpg"
import Block2 from "../../components/FeatureBlock/images/Image_2.jpg"
import Block3 from "../../components/FeatureBlock/images/Image_3.jpg"
import Block4 from "../../components/FeatureBlock/images/Image_4.jpg"
import Block5 from "../../components/FeatureBlock/images/Image_5.jpg"

const mappingScope = (array, newArray) => {
  if (array) {
    for (let i = 0; i < array.length; i++) {
      newArray[i] = {
        label: array[i].name,
        value: array[i].id,
        amount: array[i].vacancy_count
      }
    }
  }
}

class PageAbout extends Component {
  static requestData(store) {
    return requestAll([loadAbout, loadVacancies, loadCompanies, loadScopeActivity], store);
  }
  componentDidMount() {
    this.props.actions.loadAbout();
    this.props.actions.loadVacancies();
    this.props.actions.loadCompanies(this.props.filter);
    this.props.actions.loadScopeActivity(this.props.filter);
  }
  render() {
    let filteredItems = this.props.vacancies;
    const filterName = this.props.filter;
    const filterProperties = ["scope_activity", "employment", "experience", "company"];
    filterProperties.forEach(function(filterBy) {
      let filterValue = filterName[filterBy];
      if (filterValue) {
        filteredItems = filteredItems.filter(function(item) {
          for (let i = 0; i < item[filterBy].length; i++) {
            return item[filterBy][i].id === filterValue;
          }
        });
      }
    });

    const scope_activity = [];
    mappingScope(this.props.scope_activity, scope_activity);
    scope_activity.unshift({label: "Все сферы деятельности", sorting: false});
    const companies = [];
    mappingScope(this.props.companies, companies);
    companies.unshift({label: "Все компании"});

    return (
      <div>
        <Helmet>
          <title>О компании ЭР-Телеком Холдинг – Ведущая телекоммуникационная компания России</title>
          <meta name="description" content="ЭР-Телеком – одна из крупнейших телеком-компаний России. Мы разрабатываем современные решения и предоставляем интернет, телевидение и связь, делая жизнь людей и других компаний лучше." />
        </Helmet>
        <Heading modifier="heading--fullHeight"
          background={heading__about} //заменено
          background__1024={heading__about_1024} //не заменено, не понимаю в чём разница
        />
        <div className="container container--indentVertical">
          <AboutHoldingSection />
        </div>
        <HoldingAdvantages />
        <div className="container holding-sections">
          <div className="holding-sections-wrapper">
              <h2 className="holding-sections__title">Выбирай, что тебе ближе!</h2>
              <Button link="vacancies" text="Показать все вакансии" />
          </div>

        <div>
          <FeatureBlock
              title="Сопровождение услуг для физических лиц:"
              points={['Быстрый Интернет', 'Кабельное телевидение с разными пакетами каналов', 'Домашний телефон с дополнительными сервисами', 'Сервисы Movix в Интернете']}
              linkText="Наши вакансии"
              linkHref="/vacancies"
              imageSrc={Block1}
          />

          <FeatureBlock
              title="Поддержка малого и среднего бизнеса:"
              points={['Надежный Интернет', 'Видеонаблюдение', 'Wi-Fi для бизнеса', 'Цифровое телевидение', 'Облачная телефония']}
              linkText="Наши вакансии"
              linkHref="/vacancies"
              imageSrc={Block2}
              reversed
          />

          <FeatureBlock
              title="Развитие услуг для федеральных клиентов:"
              points={['Интернет', 'Техподдержка', 'Комплекс цифровых услуг и сервисов: видеонаблюдение, облачная телефония, Wi-Fi, ip-телевидение, защита от DDoS-атак, IaaS, антивирусы и многое другое']}
              linkText="Наши вакансии"
              linkHref="/vacancies"
              imageSrc={Block3}
          />

          <FeatureBlock
              title="Партнерство с государственными заказчиками:"
              points={['Городской Wi-Fi', 'Видеонаблюдение', 'Городское освещение', 'Безопасный двор', 'Опорная сеть', '«Умный город»', '«Доступная среда»']}
              linkText="Наши вакансии"
              linkHref="/vacancies"
              imageSrc={Block4}
              reversed
          />

          <FeatureBlock
              title="Участие в инновационных проектах:"
              points={['E2E-решения на основе IoT являются одним из элементов инновационных сервисов для клиентов на базе новейших мировых технологий. ', 'ЭР-Телеком Холдинг один из первых реализовал проекты на базе промышленного Интернета вещей (LoRaWAN). Сегодня в десятках отраслей и компаний тестируются и успешно эксплуатируются решения холдинга.']}
              linkText="Наши вакансии"
              linkHref="/vacancies"
              imageSrc={Block5}
          />
        </div>

        <div className="container container--noPaddinngVertTablet">
          <div className="container container--grayed container--paddingVertical container--indentVertical">
            <CitySelect main="во всех городах" modifier="citySelect--indentBottom citySelect--decrease citySelect--center">Найти работу</CitySelect>
            <div className="row row--smallOffset">
              <div className="col colVertTablet--12">
                <Select name="scopeActivity" value={{label: this.props.filter.scope_activity.label, id: this.props.filter.scope_activity.id}} options={scope_activity} placeholder="Все сферы деятельности" modifier="Select--tell" type="scope_activity" changeOption={this.props.handleChange} alphabeticSort={true} />
              </div>
              <div className="col colVertTablet--12">
                <Select name="companies" value={{label: this.props.filter.company.label, id: this.props.filter.company.id}} options={companies} placeholder="Все компании" type="company" modifier="Select--tell" changeOption={this.props.handleChange} />
              </div>
              <div className="col colVertTablet--12">
                <Button link="/vacancies" text="Найти любимую работу" modifier="button--wide" />
              </div>
          </div>
          </div>
          </div>
      </div>
    </div>
    )
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.filter !== this.props.filter) {
      this.props.actions.loadCompanies(nextProps.filter);
      this.props.actions.loadScopeActivity(nextProps.filter);
    }
  }
}

const mapStateToProps = (state) => {
  return {
      companies: state.companies.list,
      scope_activity: state.scope_activity.list,
      about: state.about.item,
      vacancies: state.vacancies.list,
      filter: state.filter
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators({loadAbout, loadVacancies, loadCompanies, loadScopeActivity}, dispatch),
    handleChange: (val, label, type) => {
      dispatch(setFilterData(val, label, type))
    }
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PageAbout));



// WEBPACK FOOTER //
// ./src/pages/PageAbout/index.js